<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="3">
                  <b-form-group
                    label-for="customer_group"
                    label="Grup Konsumen"
                  >
                    <model-select
                      id="customer_group"
                      :options="listCustomerGroup"
                      v-model="myCustomerGroup"
                      placeholder="Grup Konsumen"
                    ></model-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="province" label="Provinsi">
                    <model-select
                      id="province"
                      :options="listProvince"
                      v-model="province"
                      @input="filterRegency"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="regencies" label="Regensi">
                    <model-select
                      id="regencies"
                      :options="listRegencies"
                      v-model="regencies"
                      @input="filterDistrict"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="district" label="Distrik">
                    <model-select
                      id="district"
                      :options="listDistrict"
                      v-model="district"
                      @input="filterVillage($event)"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="village" label="Kampung">
                    <model-select
                      id="village"
                      :options="listVillage"
                      v-model="villages"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="12" class="text-right">
                  <b-button
                    size="sm"
                    variant="stack-overflow"
                    class="mr-1 btn-brand"
                    @click="getListCustomer"
                  >
                    <i class="fa fa-search"></i>
                    <span>Filter</span>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-card no-body>
      <b-card-body v-if="!loading">
        <b-row>
          <b-col sm="4">
            <b-card> 
              <label>Total Freezer : {{total_all_freeze_on_location}}</label>
            </b-card>
          </b-col>
          <b-col sm="4">
            <b-card>
              <label>Total Freezer Lebih dari 1 : {{total_freezer_more_than_1}}</label>
              </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <template>
              <GmapMap
                :center="{ lat: -6.245024128712798, lng: 106.61160232290618 }"
                :zoom="10"
                map-type-id="terrain"
                style="height: 500px"
              >
                <GmapMarker
                  :key="uniqueId(index)"
                  :title="data.name"
                  :clickable="true"
                  :position="myLocationSet(data.lat, data.lng)"
                  v-for="(data, index) in listCustomer"
                  @click="
                    center = myLocationSet(data.lat, data.lng);
                    showInformation(data);
                  "
                >
                </GmapMarker>
              </GmapMap>
            </template>
          </b-col>
        </b-row>
      </b-card-body>

      <loading v-else />
    </b-card>

    <b-modal
      ref="myModalRef"
      id="addModals"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="xl"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">{{ myDetails.name }}</h3>
      </div>

      <div v-if="!loadingProcess">
        <b-tabs>
          <b-tab title="Penempatan Asset" active>
            <asset-placement
              :customer="customerForm"
              :customer-asset="customerAsset"
              :list-asset-owner="listAssetOwner"
              :list-status-customer-asset="listStatusCustomerAsset"
              :list-employee="listEmployee"
              :child-add-button="false"
              :is-disable="true"
              :loading="loading"
            ></asset-placement>
          </b-tab>

          <b-tab title="Penempatan Asset Alternative">
            <asset-placement-alter
              :customer="customerForm"
              :customer-asset="customerAsset"
              :list-asset-owner="listAssetOwner"
              :list-status-customer-asset="listStatusCustomerAsset"
              :list-employee="listEmployee"
              :child-add-button="false"
              :is-disable="true"
              :loading="loading"
            ></asset-placement-alter>
          </b-tab>

          <b-tab title="Penarikan Asset">
            <asset-return
              :customer="customerForm"
              :customer-asset-return="customerAssetReturn"
              :customer-asset-avail="customerAsset"
              :list-asset-status="listAssetStatus"
              :loading="loading"
              :is-disable="true"
              :child-add-button="false"
              :list-employee="listEmployee"
            ></asset-return>
          </b-tab>

          <b-tab title="Dokumen Konsumen">
            <document-customer
              :customer-document="customerDocument"
              :customer="customerForm"
              :loading="loading"
              :list-document="listDocument"
              :is-disable="true"
              :child-add-button="false"
            ></document-customer>
          </b-tab>
        </b-tabs>
      </div>
      <div v-else>
        <loading></loading>
      </div>

      <div slot="modal-footer" class="float-right">
        <b-button type="button" size="sm" variant="danger" @click="closeDetail">
          <i class="fa fa-undo"></i> Back </b-button
        >&nbsp;
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import VueNotifications from "vue-notifications";
import { required, email } from "vuelidate/lib/validators";
import interfaces from "@/templates/_interfaces.js";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
import globalTable from "@/templates/Table.vue";
import { gmapApi } from "vue2-google-maps";
import assetPlacement from "../customer/tabs/AssetPlacement";
import assetPlacementAlter from "../customer/tabs/AssetPlacementAlter";
import documentCustomer from "../customer/tabs/DocumentCustomer";
import assetReturn from "../customer/tabs/AssetReturn";

export default {
  name: "freezer-location",
  components: {
    ModelSelect,
    loading,
    globalTable,
    gmapApi,
    assetPlacement,
    assetPlacementAlter,
    documentCustomer,
    assetReturn,
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      google: gmapApi,
      listCustomerGroup: [],
      myCustomerGroup: null,
      province: null,
      regencies: null,
      district: null,
      villages: null,
      listCustomer: [],
      loadingProcess: false,
      loading: false,
      myDetails: [],
      freezerInformation: [],
      customerForm: interfaces.customer,
      customerAsset: [],
      customerAssetReturn: [],
      customerDocument: [],
      listDocument: [],
      listEmployee: [],
      listAssetStatus: [],
      listStatusCustomerAsset: [],
      listAssetOwner: [],
      listProvince: [],
      listRegencies: [],
      listDistrict: [],
      listVillage: [],
      total_all_freeze_on_location: 0,
      total_freezer_more_than_1: 0
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations: {
    attendanceForm: {
      verified: { required },
    },
  },
  computed: {
    cleanUrl: function () {
      if (this.data !== null) {
        if (this.data.picture !== null) {
          let temp = this.data.picture.split(",");
          return temp[0] + "," + temp[1];
        } else {
          return this.data.picture;
        }
      } else {
        return null;
      }
    },
    dateTimeFormat: function () {
      if (this.data !== null) {
        return moment(this.data.date_inserted).format("DD MMM YYYY HH:mm:ss");
      } else {
        return null;
      }
    },
    myLocation: function () {
      if (this.data !== null) {
        return { lat: this.data.lat, lng: this.data.lng };
      } else {
        return null;
      }
    },
    myOfficeLocation: function () {
      if (this.data !== null) {
        return { lat: this.data.office_lat, lng: this.data.office_lng };
      } else {
        return null;
      }
    },
    myOfficeName: function () {
      if (this.data !== null) {
        return this.data.office_name;
      } else {
        return null;
      }
    },
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    init: function () {
      this.dropdown();
    },
    dropdown: function () {
      this.axios
        .get("web/dropdown/dropdown-freezer-location/")
        .then((response) => {
          this.listCustomerGroup = response.data.customer_group;
          this.listProvince = response.data.province;
        })
        .catch((error) => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    filterRegency: function () {
      this.regencies = null;
      this.district = null;
      this.villages = null;
      this.listRegencies = [];
      this.listDistrict = [];
      this.listVillage = [];
      this.axios
        .get("/web/dropdown/regency/" + this.province)
        .then((response) => {
          this.listRegencies = response.data.data;
        });
    },
    filterDistrict: function () {
      this.district = null;
      this.villages = null;
      this.listDistrict = [];
      this.listVillage = [];
      this.axios
        .get("/web/dropdown/district/" + this.regencies)
        .then((response) => {
          this.listDistrict = response.data.data;
        });
    },
    filterVillage: function (event) {
      this.villages = null;
      this.listVillage = [];
      this.axios
        .get("/web/dropdown/village/" + this.district)
        .then((response) => {
          this.listVillage = response.data.data;
        });
    },
    myLocationSet: function (lat = null, lng = null) {
      if (lat !== null) {
        return { lat: parseFloat(lat), lng: parseFloat(lng) };
      } else {
        return null;
      }
    },
    getListCustomer: function () {
      let param = {};
      param.customer_group = this.myCustomerGroup;
      param.province = this.province;
      param.regencies = this.regencies;
      param.district = this.district;
      param.villages = this.villages;

      this.loading = true;

      this.axios
        .post("web/freezer/location", param)
        .then((response) => {
          this.listCustomer = response.data.customer;
          this.total_all_freeze_on_location = response.data.total_all_freezer_on_location;
          this.total_freezer_more_than_1 = response.data.total_freezer_on_location_more_than_1;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    showInformation: function (data) {
      this.loadingProcess = true;
      this.$refs.myModalRef.show();
      this.myDetails = data;
      this.axios
        .get("web/customer/detail/" + data.id + "/")
        .then((response) => {
          this.customerForm = response.data.data;
          this.customerAsset = response.data.customer_assets;
          this.customerDocument = response.data.customer_document;
          this.customerAssetReturn = response.data.customer_assets_return;
        })
        .catch((error) => {})
        .finally(() => {
          this.loadingProcess = false;
        });
    },
    closeDetail: function () {
      this.$refs.myModalRef.hide();
      this.myDetails = [];
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Verifikasi karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>